import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useVisualViewportHeight } from '@leanpay/hooks'
import { A11yAnnouncer, cn } from '@leanpay/ui'

import { useAppStore } from './app-store'
import CheckoutHeader from './components/checkout-header/checkout-header'
import {
    currentMarket,
    isMarketHun,
    isMarketRom,
    isMarketSlo,
    isProdEnvironment,
} from 'library/constants'
import { lazyWithRetry } from 'library/lazy-with-retry'
import { handleProgress } from 'library/utils'

const MainAppROM = lazyWithRetry(() => import('./markets/rom/main-app-rom'))

const MainLayout = () => {
    const { i18n } = useTranslation()
    const location = useLocation()
    const { progress, setProgress, isAuthenticated, vendorToken } = useAppStore()

    useVisualViewportHeight()

    useEffect(() => {
        handleProgress(location.pathname, setProgress)
    }, [location.pathname, setProgress])

    const renderApp = () => {
        if (isMarketRom) return <MainAppROM />

        throw Error(`Error in main-layout.tsx: renderApp() - Market: ${currentMarket}`)
    }

    const marketLanguage = isMarketHun ? 'hu' : isMarketSlo ? 'sl' : 'ro'

    return (
        <>
            <meta name="token" content={vendorToken} />
            {!isProdEnvironment && (
                <div className="fixed pl-[70px] top-[30px] z-[1000] flex gap-2 justify-start">
                    <p
                        onClick={() => {
                            void i18n.changeLanguage('en')
                        }}
                        className={cn(
                            'cursor-pointer',
                            i18n.language === 'en' ? 'text-lp-peach1' : 'text-lp-dark1',
                        )}
                    >
                        EN
                    </p>
                    <p
                        onClick={() => {
                            void i18n.changeLanguage(marketLanguage)
                        }}
                        className={cn(
                            'cursor-pointer',
                            i18n.language === 'en' ? 'text-lp-dark1' : 'text-lp-peach1',
                        )}
                    >
                        {String(marketLanguage).toUpperCase()}
                    </p>
                </div>
            )}
            <div className="main-layout self-center flex flex-col items-center overflow-y-auto overscroll-none min-[900px]:scroll-smooth max-w-[840px] w-full bg-lp-grey2 rounded-lg min-[900px]:max-h-[95vh] min-[900px]:min-h-[95vh] max-[766px]:rounded-none max-[766px]:h-full max-[766px]:max-w-full max-[766px]:pb-30 min-[767px]:max-[899px]:rounded-none min-[767px]:max-[899px]:h-full min-[767px]:max-[899px]:max-w-full min-[767px]:max-[899px]:pb-30">
                <A11yAnnouncer />
                <CheckoutHeader showCancelIcon={isAuthenticated} progress={progress}>
                    {renderApp()}
                </CheckoutHeader>
            </div>
        </>
    )
}

export default MainLayout
